import { styled } from '@/stitches.config';

import { Box } from '@common/components';

export const StyledContainer = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  padding: '$5',
});

export const StyledContent = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
});

export const StyledReopen = styled(Box, {
  color: '$darkBlue300',
  fontSize: '$xl',
  fontWeight: '$bold',
  lineHeight: '$10',
  marginBottom: '$2',
});

export const StyledMoved = styled(Box, {
  color: '$charcoal300',
  fontSize: '$md',
  lineHeight: '$8',
});

export const StyledButtonContainer = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',
  marginTop: '$8',
});
